module.exports = __webpack_public_path__ + "img/blog-gb-whatsapp-temporary-ban.123f042f.png";